<template>
  <div class="mceBanner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">整合容器技术，提供高可用的应用托管和数据库服务并覆盖DevOps全域管理</span>
        <div class="try-btn-area">
          <div class="btn-contactUs" @click="dialogVisible=true">立即体验</div>
        </div>
      </div>
    </div>
    <el-dialog class="mce-dialog" title="感谢关注MoPaaS容器云平台，平台暂未开放公有云服务，如需试用，请联系客服。"
               :visible.sync="dialogVisible">
      <div style="display: flex;align-items: center; justify-content:center;">
        <a style="text-decoration: none; font-size:14px; "
           href="http://wpa.qq.com/msgrd?v=3&amp;uin=2629198267&amp;site=qq&amp;menu=yes" target="_blank">
          <img src="@/assets/images/qq(2).png" style="width: 35px">
          <p style="margin-left:10px ;color: #349CE3;display: initial;font-size:14px;">2629198267</p>
        </a>
      </div>
      <div style="display: flex;align-items: center; justify-content:center; margin-top:20px;">
        <img alt="" src="@/assets/images/phone.png" style="width: 29px;">
        <p style="margin-left:10px;color: #349CE3;font-size:14px;">021-54011298</p>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    name: 'MceBanner',
    data() {
      return {
        dialogVisible: false
      }
    }
  }
</script>

<style>
  @media(min-width:992px) {
    .mceBanner {
      width: 100%;
      height: 38.49vw;
      margin-top: 72px;
      overflow-y: hidden;
      background-image: url("../assets/images/mcebanner.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .mceBanner .center {
      width: auto !important;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-left: 13.54vw;
    }

    .mceBanner .banner-overlay1 {
      padding-top: 183px;
      color: #FFFFFF;
      text-align: left;
    }


    .mceBanner .banner-overlay1 .title {
      width: 966px;
      /*height: 210px;*/
      font-size: 42px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 70px;
      display: inline-block;
    }

    .mceBanner .btn-contactUs {
      margin-top: 41px;
      cursor: pointer;
      color: #ffffff;
      width: 168px;
      height: 58px;
      border-radius: 29px;
      background: linear-gradient(90deg, rgba(39, 46, 63, 0.38) 0%, rgba(33, 36, 51, 0.34) 100%), url('../assets/images/svg/btnborder.svg');
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 400;
    }
    .mce-dialog .el-dialog{
      width: 445px;
    }
  }
  @media(max-width:992px) {
    .mceBanner {
      width: 100%;
      height: 38.5vw;
      margin-top: 8vw;
      overflow-y: hidden;
      background-image: url("../assets/images/mcebanner.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .mceBanner .center {
      width: auto !important;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-left: 4vw;
    }

    .mceBanner .banner-overlay1 {
      padding-top: 10vw;
      color: #FFFFFF;
      text-align: left;
    }


    .mceBanner .banner-overlay1 .title {
      width: 54vw;
      font-size: 12px;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 16px;
      display: inline-block;
    }

    .mceBanner .btn-contactUs {
      width: 24vw;
      margin-top: 6vw;
      height: 4vw;
      cursor: pointer;
      color: #fff;
      border: 1px solid #ffffff;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 300;
      padding: 2vw;
    }
    .mce-dialog .el-dialog{
      width: 80%;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/MceBanner.vue